import React, { Component } from "react";
import {
  List,
  Edit,
  Datagrid,
  TextField,
  ReferenceField,
  Button,
  ReferenceInput,
  EditButton,
  GET_ONE,
  BooleanField,
  DateField,
  ImageField,
  BooleanInput,
  AutocompleteInput,
  SelectInput,
  Toolbar,
  SaveButton,
  SimpleForm,
  Filter,
  useTranslate
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "react-responsive-modal";
// import DateFnsUtils from '@date-io/date-fns';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
// import mwLocale from "date-fns/locale/en_MW";
import myDataProvider from "../myRestProvider";
import noImage from "./../images/combined-shape.svg";
import moment from "moment";
import { CREATE } from "ra-core";
import { getLocalStorageKey } from "../common/common";

const StatusField = ({ record = {}, source }) => (
  <span>{record[source] === null ? "-" : record[source] ? "Yes" : "No"}</span>
);

const selectInputStyle = {
  width: 200,
};

const PostFilter = (props) => {
  return (
    <Filter {...props}>
      <SelectInput
        source="status"
        choices={[
          { id: true, name: "True" },
          { id: false, name: "False" },
        ]}
      />
    </Filter>
  );
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};

const DashboardBannerList = (props) => {
  const translate = useTranslate();

  return (
    <Scrollbars className="scroll-container">
      <List
        {...props}
        filters={<PostFilter />}
        sort={{ field: "created_at", order: "DESC" }}
        title={translate('resources.dashboard_banners.fields.mobile_home_banner')}
        exporter={false}
      >
        <Datagrid bulkActionButtons={false}>
          <DateField
            source="created_at"
            showTime
            sortable={false}
          />
          <TextField source="position" allowEmpty />
          <ImageField
            source="image_data"
            label="Image"
          />
          <BooleanField source="status" />
          <EditButton source="edit" sortable={false}/>
        </Datagrid>
      </List>
    </Scrollbars>
  );
};

export default DashboardBannerList;
